import { useGrantCameraAccess } from "@/hooks/tauri/useGrantCameraAccess";
import { useInterceptMediaCommands } from "./useInterceptMediaCommands";
import { usePreventNavigationAndReload } from "./usePreventUserReload";
import { useMoveAppToFolderOnMacOS } from "@/hooks/tauri/useMoveAppToFolder";
import { useCheckOverTheAirUpdates } from "./useCheckOverTheAirUpdates";

export const useInitializeDesktopApp = () => {
  useMoveAppToFolderOnMacOS();
  useInterceptMediaCommands();
  useGrantCameraAccess();
  usePreventNavigationAndReload();
  useCheckOverTheAirUpdates();
};
